import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {SCOPE_HOST} from '~/SignUpSheets/reducers/sheet/constants';
import {schemaToJson} from '~/SignUpSheets/utils/schema';

export const contentApi = createApi({
  reducerPath: 'contentApi',
  baseQuery: fetchBaseQuery({baseUrl: `${window.location.origin}/services/content`}),
  endpoints: (builder) => ({
    getTemplates: builder.query({
      query: () => ({
        url: `/signup-sheet-templates`,
        // biome-ignore lint/style/useNamingConvention: existing error
        params: {make_protocol_relative: false},
      }),
      transformResponse: (data, meta, arg) => {
        const {id: templateId, type, schema} = arg;
        const template = data.find((d) => d.template_id === templateId && d.sheet_type === type);
        template.signup_options = (template.signup_options ?? []).map((so) =>
          schemaToJson(schema, type, SCOPE_HOST, so, true)
        );
        return template;
      },
    }),
  }),
});

export const {useLazyGetTemplatesQuery} = contentApi;
